//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import find from 'lodash/find'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { TRACKER_HIDDEN_ACTION, TRACKER_CLICK } from '@/scripts/constants/tracker'
import { getStoreDirectionsLink } from '@/scripts/libs/store-locator'
import { mapGetters } from 'vuex'
import { APPOINTMENT_BOOKING_SERVICE_NAME, NA } from '@/scripts/constants/store-locator'

export default {
  name: 'rb-store-locator-list-item',
  props: {
    store: {
      type: Object,
      default: () => {
        return {
          name: '',
        }
      },
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    mapProvider: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      appointmentBookingUrl: '',
      isTelephoneNumberNAClicked: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    getStoreName() {
      return this.store.storeName
    },
    getStore() {
      return this.store
    },
    getIcon() {
      return `common__icon--physical-store-${this.store.storeType}`
    },
    getStoreAddress() {
      return this.store?.address
    },
    getTelephoneNumber() {
      return this.store.telephone
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    getOpeningHours() {
      if (this.store.openingHours && this.store.closingHours) {
        return `${this.store.openingHours} - ${this.store.closingHours}`
      }
      return ''
    },
  },
  mounted() {
    const appointmentBookingService = find(
      this.store.services,
      (item) => item.name === APPOINTMENT_BOOKING_SERVICE_NAME
    )

    if (appointmentBookingService) {
      this.appointmentBookingUrl = appointmentBookingService.url
    }
  },
  methods: {
    onSelectedStore() {
      if (!this.isTelephoneNumberNAClicked) {
        this.$emit('storeSelected', this.store.uniqueID)
      }
      this.isTelephoneNumberNAClicked = false
    },
    onSelectStoreFromMap() {
      this.$el?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: 'X_X_Store_Choose',
        },
      })
    },
    onAppointmentBookingClick() {
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: 'X_X_Store_BookAppointment',
        },
      })

      const queryParams = new URLSearchParams(window.location.search)
      const bookingToolQueryParam = queryParams.get('appType') ?? undefined
      if (bookingToolQueryParam) {
        window.location.href = `${this.appointmentBookingUrl}&appType=${bookingToolQueryParam}`
      } else {
        window.location.href = this.appointmentBookingUrl
      }
    },
    callStore() {
      if (this.getTelephoneNumber !== NA) {
        window.location.href = `tel:${String(this.store.telephone).trim()}`
      } else {
        this.isTelephoneNumberNAClicked = true
      }
    },
    showStoreDirectionsOnSeparateMap() {
      window.open(
        getStoreDirectionsLink(this.store.latitude, this.store.longitude, this.mapProvider),
        '_blank'
      )
    },
  },
}
